import { formatBgScanChannelList, parseBgScanChannelList } from './bgScanPatchUtils';

/** Default treemgmt channel allow-lists (matches backend defaultAllowedChannelLookup). */
export const DEFAULT_CHANNELS_5GHZ = [
  36, 40, 44, 48, 52, 56, 60, 64,
  100, 104, 108, 112, 116, 120, 124, 128, 132, 136, 140,
  149, 153, 157, 161, 165,
];

export const DEFAULT_CHANNELS_6GHZ = [
  5, 13, 21, 29, 37, 45, 53, 61, 69, 77, 85, 93,
  101, 109, 117, 125, 133, 141, 149, 157, 165, 173, 181, 189, 197, 205, 213, 221, 229,
];

const CHANNEL_MAX_BW_5GHZ = {
  36: 80, 40: 80, 44: 80, 48: 80,
  52: 80, 56: 80, 60: 80, 64: 80,
  100: 80, 104: 80, 108: 80, 112: 80,
  116: 80, 120: 80, 124: 80, 128: 80,
  132: 40, 136: 40, 140: 40,
  149: 80, 153: 80, 157: 80, 161: 80,
  165: 20,
};

function htModeToMHz(htmode) {
  switch (String(htmode || '').toUpperCase()) {
    case 'HT160': return 160;
    case 'HT80': return 80;
    case 'HT40': return 40;
    default: return 20;
  }
}

function channelMaxBandwidthMHz(band, channel) {
  if (band === '5GHz') {
    return CHANNEL_MAX_BW_5GHZ[channel] ?? 20;
  }
  if (band === '6GHz') {
    return 80;
  }
  return 20;
}

function filterChannelsByBandwidth(band, candidates, requiredBwMHz) {
  if (requiredBwMHz <= 20) {
    return candidates;
  }
  return candidates.filter((ch) => channelMaxBandwidthMHz(band, ch) >= requiredBwMHz);
}

export function defaultChannelsForBandAndHtmode(band, htmode = 'HT80') {
  if (band === '5GHz') {
    return filterChannelsByBandwidth('5GHz', DEFAULT_CHANNELS_5GHZ, htModeToMHz(htmode));
  }
  if (band === '6GHz') {
    return filterChannelsByBandwidth('6GHz', DEFAULT_CHANNELS_6GHZ, htModeToMHz(htmode));
  }
  return [];
}

export function formatTreemgmtChannelList(channels) {
  return formatBgScanChannelList(channels);
}

export function parseTreemgmtChannelList(raw) {
  return parseBgScanChannelList(raw);
}

/**
 * Build channel_groups for tm-params-update: only the selected band is sent,
 * which replaces the entire treemgmt ChannelGroups map on the device.
 */
export function buildConnectivityChannelGroups(band, channelsRaw) {
  if (!['5GHz', '6GHz'].includes(band)) {
    return { error: 'Select 5GHz or 6GHz before setting channels' };
  }
  const trimmed = String(channelsRaw ?? '').trim();
  if (!trimmed) {
    return { channelGroups: null };
  }
  const parsed = parseTreemgmtChannelList(trimmed);
  if (parsed.error) {
    return { error: parsed.error };
  }
  if (!parsed.channels?.length) {
    return { error: 'Provide at least one channel' };
  }
  return { channelGroups: { [band]: parsed.channels } };
}
